/*
 * DO NOT DELETE
 * This file is necessary because react-native-fbsdk-next is not supported in mobile web
 * Application will break if this file is deleted
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const trackAppFlyer = (_username: string) => {
  // Do nothing
};

export default trackAppFlyer;
